import { Action } from '@ngrx/store';
import { ExportJobRequest, ExportJob } from '@eview/core/domain/export/export';
import { ListPostOptions } from '@eview/core/domain/post/post';
import { UsersHelpers } from '@eview/core/users/users.helpers';

export enum EExportActions {
  CreateJob = '[Export] Create Job',
  CreateJobSuccess = '[Export] Create Job success',
  CreateJobFailure = '[Export] Create Job failure',
  CheckLastJobSuccess = '[Export] Check Last Job success',
  LastJobSuccess = '[Export] Last Job success',
  LastJobFailure = '[Export] Last Job failure',
  ExportPost = '[Export] Exports Posts',
  ExportPostSuccess = '[Export] Exports Posts success',
  ExportPostFailure = '[Export] Exports Posts failure',
  ExportUsers = '[Export] Exports Users',
  ExportUsersSuccess = '[Export] Exports Users success',
  ExportUsersFailure = '[Export] Exports Users failure'
}

export class CreateJob implements Action {
  readonly type = EExportActions.CreateJob;
  constructor(public payload: ExportJobRequest) {}
}

export class CreateJobSuccess implements Action {
  readonly type = EExportActions.CreateJobSuccess;
  constructor(public payload: ExportJob) {}
}

export class CreateJobFailure implements Action {
  readonly type = EExportActions.CreateJobFailure;
}

export class CheckLastJobSuccess implements Action {
  readonly type = EExportActions.CheckLastJobSuccess;
  constructor(public payload: number) {}
}

export class LastJobSuccess implements Action {
  readonly type = EExportActions.LastJobSuccess;
  constructor(public payload: ExportJob) {}
}

export class LastJobFailure implements Action {
  readonly type = EExportActions.LastJobFailure;
}

export class ExportPost implements Action {
  readonly type = EExportActions.ExportPost;
  constructor(public payload: ListPostOptions & { columns?: string }) {}
}

export class ExportPostSuccess implements Action {
  readonly type = EExportActions.ExportPostSuccess;
  constructor(public payload: any) {}
}

export class ExportPostFailure implements Action {
  readonly type = EExportActions.ExportPostFailure;
}

export class ExportUsers implements Action {
  readonly type = EExportActions.ExportUsers;
}

export class ExportUsersSuccess implements Action {
  readonly type = EExportActions.ExportUsersSuccess;
  constructor(public payload: any) {
    if (payload.success === true) {
      const rows = [payload.headers];
      payload.data.forEach(element => {
        rows.push(Object.values(element));
      });
      UsersHelpers.ExportDataCSV('User_Reports', rows);
    }
  }
}

export class ExportUsersFailure implements Action {
  readonly type = EExportActions.ExportUsersFailure;
}

export type ExportActions =
  | CreateJob
  | CreateJobSuccess
  | CreateJobFailure
  | CheckLastJobSuccess
  | LastJobSuccess
  | LastJobFailure
  | ExportPost
  | ExportPostSuccess
  | ExportPostFailure
  | ExportUsers
  | ExportUsersSuccess
  | ExportUsersFailure;
